import * as React from "react";
import { Loader } from "../../components/loader/Loader";
import { getBuildingStatistics } from "../../redux/actions/statisticsActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getOccupancyOverview } from "./occupancyStatistics";
import { OccupancySummary } from "./OccupancySummary";
import { OccupancyOverviewHeader } from "./OccupancyOverviewHeader";
import { OccupancyOverviewBuilding } from "./OccupancyOverviewBuilding";

export const OccupancyOverview: React.FC = () => {
  const dispatch = useAppDispatch();
  const buildingStatistics = useAppSelector((state) => state.statistics.buildingStatistics);
  const [status, setStatus] = React.useState<"Loading" | "Loaded" | "Failed">("Loading");
  const [retry, setRetry] = React.useState(0);
  const { buildings, totals } = React.useMemo(() => getOccupancyOverview(buildingStatistics), [buildingStatistics]);

  React.useEffect(() => {
    let active = true;
    setStatus("Loading");
    dispatch(getBuildingStatistics()).then((action) => {
      if (active) setStatus(getBuildingStatistics.fulfilled.match(action) ? "Loaded" : "Failed");
    });
    return () => {
      active = false;
    };
  }, [dispatch, retry]);

  return (
    <main className="main occupancy-overview-page">
      <OccupancyOverviewHeader />
      <div className="wrap">
        <div className="stats-results stats-results--open occupancy-overview" aria-busy={status === "Loading"}>
          {status === "Loading" ? (
            <>
              <Loader />
              <p role="status">Loading occupancy statistics...</p>
            </>
          ) : status === "Failed" ? (
            <div role="alert">
              <p>Occupancy statistics could not be loaded. Please try again.</p>
              <button className="btn" type="button" onClick={() => setRetry((value) => value + 1)}>
                Retry
              </button>
            </div>
          ) : (
            <>
              <section className="occupancy-overview__overall" aria-labelledby="occupancy-overview-total">
                <div className="occupancy-overview__row">
                  <h3 className="stats-results__name occupancy-overview__name">All locations</h3>
                  <OccupancySummary totals={totals} />
                </div>
              </section>
              {buildings.length === 0 ? (
                <p>No buildings available.</p>
              ) : (
                <>
                  <p className="occupancy-overview__hint">Expand a building to see its floors.</p>
                  {buildings.map((building) => (
                    <OccupancyOverviewBuilding key={building.id} building={building} />
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </main>
  );
};
